export default {
  // House search page
  'pages.search.house.tab.all': 'All Houses',
  'pages.search.house.tab.favorite': 'My Favorites',

  // House management page
  'pages.house.title': 'House Management',
  'pages.house.subTitle': 'Manage house information in the community',
  'pages.house.breadcrumb.property': 'Property Management',
  'pages.house.breadcrumb.baseData': 'Base Data',
  'pages.house.breadcrumb.house': 'House Management',

  // House table
  'pages.house.table.title': 'House List',
  'pages.house.table.columns.floor': 'Floor',
  'pages.house.table.columns.building': 'Building Name',
  'pages.house.table.columns.houseNumber': 'House Number',
  'pages.house.table.columns.houseType': 'House Type',
  'pages.house.table.columns.area': 'Building Area (㎡)',
  'pages.house.table.columns.price': 'Amount (CNY)',
  'pages.house.table.columns.reserveAmount': 'Reserve Amount',
  'pages.house.table.columns.status': 'House Status',
  'pages.house.table.columns.ownerName': 'Owner Name',
  'pages.house.table.columns.ownerPhone': 'Owner Phone',
  'pages.house.table.columns.createdTime': 'Created Time',
  'pages.house.table.columns.operations': 'Operations',
  'pages.house.table.tab.all': 'All',
  'pages.house.table.tab.reserved': 'Reserved',

  // House status
  'pages.house.status.vacant': 'Vacant',
  'pages.house.status.rented': 'Rented',
  'pages.house.status.sold': 'Sold',
  'pages.house.status.repairing': 'Under Repair',
  'pages.house.detail.status.unknown': 'Status {status}',

  // Action buttons
  'pages.house.actions.view': 'View',
  'pages.house.actions.sell': 'Sell',

  // House detail modal
  'pages.house.detail.title': 'House Details',
  'pages.house.detail.loading': 'Loading...',
  'pages.house.detail.tab.basic': 'Basic Info',
  'pages.house.detail.tab.sale': 'Sale Info',
  'pages.house.detail.tab.rent': 'Rental Info',
  'pages.house.detail.tab.bills': 'Bills',
  'pages.house.detail.tab.services': 'Utilities Setup',
  'pages.house.detail.tab.repairComplaint': 'Warranty & Complaints',
  'pages.house.detail.tab.entryRegistration': 'Entry Registration',
  'pages.house.detail.tab.repayment': 'House Repayment',
  'pages.house.detail.tab.document': 'Related Documents',
  'pages.house.detail.tab.operationLog': 'Operation Log',
  'pages.house.detail.loading': 'Loading...',

  // House related documents
  'pages.house.document.table.title': 'Related Documents',
  'pages.house.document.table.columns.category': 'Document Category',
  'pages.house.document.table.columns.fileType': 'File Type',
  'pages.house.document.table.columns.fileSize': 'File Size',
  'pages.house.document.table.columns.createdBy': 'Created By',
  'pages.house.document.table.columns.createdTime': 'Created Time',
  'pages.house.document.table.columns.remarks': 'Remarks',
  'pages.house.document.table.columns.action': 'Action',
  'pages.house.document.action.add': 'Add Document',
  'pages.house.document.action.download': 'Download',
  'pages.house.document.action.chooseFile': 'Choose File',
  'pages.house.document.action.uploading': 'Uploading',
  'pages.house.document.action.create': 'Add',
  'pages.house.document.action.update': 'Update',
  'pages.house.document.modal.createTitle': 'Add Document',
  'pages.house.document.modal.editTitle': 'Edit Document',
  'pages.house.document.form.category.label': 'Document Category',
  'pages.house.document.form.category.placeholder': 'Please select document category',
  'pages.house.document.form.category.required': 'Please select document category',
  'pages.house.document.form.file.label': 'Document File',
  'pages.house.document.form.remarks.label': 'Remarks',
  'pages.house.document.form.remarks.placeholder': 'Please enter remarks',
  'pages.house.document.form.remarks.maxLength': 'Remarks cannot exceed 500 characters',
  'pages.house.document.tip.uploaded': '✓ Uploaded: {name}',
  'pages.house.document.message.uploadSuccess': 'File uploaded successfully',
  'pages.house.document.message.uploadFailed': 'File upload failed',
  'pages.house.document.message.createSuccess': 'Document added successfully',
  'pages.house.document.message.createFailed': 'Add failed',
  'pages.house.document.message.updateSuccess': 'Document updated successfully',
  'pages.house.document.message.updateFailed': 'Update failed',
  'pages.house.document.message.deleteSuccess': 'Document deleted successfully',
  'pages.house.document.message.deleteFailed': 'Delete failed',
  'pages.house.document.warning.noFilePath': 'File path does not exist',
  'pages.house.document.error.noBizId': 'House ID does not exist',
  'pages.house.document.validation.fileRequired': 'Please upload a file first',
  'pages.house.document.confirm.delete.title': 'Confirm Deletion',
  'pages.house.document.confirm.delete.content': 'Are you sure you want to delete document "{name}"?',
  'pages.house.detail.basicInfo': 'Basic Information',
  'pages.house.detail.ownerInfo': 'Owner Information',
  'pages.house.detail.saleInfo': 'Sale Information',
  'pages.house.detail.rentalInfo': 'Rental Information',
  'pages.house.detail.priceInfo': 'Price Information',
  'pages.house.detail.systemInfo': 'System Information',

  // House operation log
  'pages.house.operationLog.title': 'Operation Log',
  'pages.house.operationLog.action.refresh': 'Refresh',
  'pages.house.operationLog.columns.createdTime': 'Operation Time',
  'pages.house.operationLog.columns.logType': 'Operation Type',
  'pages.house.operationLog.columns.message': 'Operation Message',
  'pages.house.operationLog.columns.operatorName': 'Operator',
  'pages.house.operationLog.columns.operatorIp': 'Operator IP',
  'pages.house.finance.table.title': 'Financial Registration Records',
  'pages.house.finance.action.create': 'Create Registration',
  'pages.house.finance.column.applyTime': 'Apply Time',
  'pages.house.finance.column.feeType': 'Fee Type',
  'pages.house.finance.column.amount': 'Amount',
  'pages.house.finance.column.status': 'Status',
  'pages.house.finance.column.applicant': 'Applicant',
  'pages.house.finance.column.remarks': 'Remarks',
  'pages.house.finance.status.pending': 'Pending',
  'pages.house.finance.status.approved': 'Paid',
  'pages.house.finance.status.rejected': 'Cancelled',
  'pages.house.finance.feeType.unknown': 'Unknown',
  'pages.house.finance.modal.createTitle': 'Create Financial Registration',
  'pages.house.finance.form.houseInfo': 'House Information',
  'pages.house.finance.form.amountType': 'Amount Type',
  'pages.house.finance.form.amountType.placeholder': 'Please select amount type',
  'pages.house.finance.form.amountType.required': 'Please select amount type',
  'pages.house.finance.form.amountType.in': 'Income',
  'pages.house.finance.form.amountType.out': 'Expense',
  'pages.house.finance.form.feeType': 'Fee Type',
  'pages.house.finance.form.feeType.dictLabel': 'Real Estate Fee Type',
  'pages.house.finance.form.feeType.placeholder': 'Please select fee type',
  'pages.house.finance.form.feeType.required': 'Please select fee type',
  'pages.house.finance.form.amount': 'Amount',
  'pages.house.finance.form.amount.placeholder': 'Please enter amount',
  'pages.house.finance.form.amount.required': 'Please enter amount',
  'pages.house.finance.form.bankStatement': 'Bank Statement',
  'pages.house.finance.form.bankStatement.placeholder': 'Please enter keywords to search bank statements',
  'pages.house.finance.form.bankStatement.required': 'Please select bank statement',
  'pages.house.finance.form.remarks': 'Remarks',
  'pages.house.finance.form.remarks.placeholder': 'Please enter remarks',
  'pages.house.finance.message.houseIdMissing': 'House ID does not exist',
  'pages.house.finance.message.createSuccess': 'Financial registration successful',
  'pages.house.finance.message.createFailed': 'Financial registration failed',
  'pages.house.finance.message.createRetry': 'Financial registration failed, please try again later',
  'pages.house.finance.error.loadFeeTypeFailed': 'Failed to load fee type dictionary',
  'pages.house.finance.error.searchBankStatementFailed': 'Failed to search bank statements',

  // House sale (Detail - Sale tab)
  'pages.house.sale.section.saleAmount': 'Sale Amount',
  'pages.house.sale.section.saleInfo': 'Sale Information',
  'pages.house.sale.section.loanInfo': 'Loan Information',
  'pages.house.sale.section.reserveInfo': 'Reservation Information',
  'pages.house.sale.section.agentInfo': 'Agent Information',
  'pages.house.sale.button.viewRepaymentPlan': 'View Repayment Plan',
  'pages.house.sale.repaymentPlan.title': 'Mortgage Repayment Plan',
  'pages.house.sale.soldType.loan': 'Loan',
  'pages.house.sale.soldType.fullPayment': 'Full Payment',
  'pages.house.sale.label.salePrice': 'Sale Price',
  'pages.house.sale.label.vat': 'VAT',
  'pages.house.sale.label.transferFee': 'Transfer Fee',
  'pages.house.sale.label.agentBonus': 'Agent Bonus',
  'pages.house.sale.label.personalBonus': 'Personal Bonus',
  'pages.house.sale.label.contractTotalPrice': 'Contract Total Price',
  'pages.house.sale.label.companyFinalProfit': 'Company Final Profit',
  'pages.house.sale.label.soldType': 'Sale Type',
  'pages.house.sale.label.soldTime': 'Sold Time',
  'pages.house.sale.label.mortgageStartTime': 'Mortgage Start Time',
  'pages.house.sale.label.mortgageEndTime': 'Mortgage End Time',
  'pages.house.sale.label.monthlyRepaymentLimit': 'Monthly Repayment Limit',
  'pages.house.sale.label.reserveUserName': 'Reserved By',
  'pages.house.sale.label.reserveUserPhone': 'Reserved Phone',
  'pages.house.sale.label.reserveAmount': 'Reserved Amount',
  'pages.house.sale.label.reserveTime': 'Reserved Time',
  'pages.house.sale.label.agentName': 'Agent Name',
  'pages.house.sale.label.agentPhone': 'Agent Phone',
  'pages.house.sale.label.agentCommission': 'Agent Commission',
  'pages.house.sale.label.mortgageTimeRange': 'Mortgage Repayment Time',
  'pages.house.sale.placeholder.salePrice': 'Please enter sale price',
  'pages.house.sale.placeholder.vat': 'Please enter VAT',
  'pages.house.sale.placeholder.transferFee': 'Please enter transfer fee',
  'pages.house.sale.placeholder.agentBonus': 'Please enter agent bonus',
  'pages.house.sale.placeholder.personalBonus': 'Please enter personal bonus',
  'pages.house.sale.placeholder.autoCalculated': 'Auto calculated',
  'pages.house.sale.placeholder.soldType': 'Please select sale type',
  'pages.house.sale.placeholder.mortgageStartMonth': 'Start month',
  'pages.house.sale.placeholder.mortgageEndMonth': 'End month',
  'pages.house.sale.validation.salePriceMin': 'Sale price cannot be negative',
  'pages.house.sale.validation.vatMin': 'VAT cannot be negative',
  'pages.house.sale.validation.transferFeeMin': 'Transfer fee cannot be negative',
  'pages.house.sale.validation.agentBonusMin': 'Agent bonus cannot be negative',
  'pages.house.sale.validation.personalBonusMin':
    'Personal bonus cannot be negative',
  'pages.house.sale.validation.soldTypeRequired': 'Please select sale type',
  'pages.house.sale.tooltip.contractTotalPrice':
    'Contract total price = Sale price + VAT + transfer fee',
  'pages.house.sale.tooltip.companyFinalProfit':
    'Company final profit = Sale price - agent commission - agent bonus - personal bonus',

  // Detail field labels
  'pages.house.detail.label.building': 'Building',
  'pages.house.detail.label.floor': 'Floor',
  'pages.house.detail.label.houseNumber': 'House Number',
  'pages.house.detail.label.houseType': 'House Type',
  'pages.house.detail.label.area': 'Building Area',
  'pages.house.detail.label.status': 'House Status',
  'pages.house.detail.label.ownerName': 'Owner Name',
  'pages.house.detail.label.ownerPhone': 'Owner Phone',
  'pages.house.detail.label.saleAmount': 'Sale Amount',
  'pages.house.detail.label.discountAmount': 'Discount Amount',
  'pages.house.detail.label.finalAmount': 'Final Amount',
  'pages.house.detail.label.monthlyRepaymentLimit': 'Monthly Repayment Amount',
  'pages.house.detail.label.saleTime': 'Sale Time',
  'pages.house.detail.label.rent': 'Rent',
  'pages.house.detail.label.rentPeriod': 'Lease Period',
  'pages.house.detail.label.houseAmount': 'House Amount',
  'pages.house.detail.label.createdTime': 'Created Time',
  'pages.house.detail.label.updatedTime': 'Updated Time',
  'pages.house.detail.label.remarks': 'Remarks',

  // Repayment plan (viewer)
  'pages.house.repaymentPlan.title': 'Repayment Plan',
  'pages.house.repaymentPlan.stat.total': 'Total Repayment',
  'pages.house.repaymentPlan.stat.monthlyAvg': 'Monthly Average',
  'pages.house.repaymentPlan.stat.months': 'Repayment Months',
  'pages.house.repaymentPlan.unit.months': 'Months',
  'pages.house.repaymentPlan.empty': 'No repayment plan data',
  'pages.house.repaymentPlan.loadFailed': 'Failed to load repayment plan',
  'pages.house.repaymentPlan.label.year': '{year}',
  'pages.house.repaymentPlan.yearTotal': 'Year Total',
  'pages.house.repaymentPlan.monthRepayment': '{month} Repayment',

  // Repayment config (yearly plan)
  'pages.house.repaymentConfig.button.open': 'Configure Repayment Plan',
  'pages.house.repaymentConfig.modal.title': 'Yearly Repayment Plan Configuration',
  'pages.house.repaymentConfig.quickGenerate.title': 'Quick Generate Plan',
  'pages.house.repaymentConfig.quickGenerate.button': 'Generate Plan',
  'pages.house.repaymentConfig.quickGenerate.start': 'Start Time',
  'pages.house.repaymentConfig.quickGenerate.end': 'End Time',
  'pages.house.repaymentConfig.quickGenerate.limit': 'Monthly Repayment Limit (¥)',
  'pages.house.repaymentConfig.tip.needMortgageConfig': 'Please configure mortgage time range and monthly repayment limit first',
  'pages.house.repaymentConfig.warning.needMortgageConfig': 'Please configure mortgage time range and monthly repayment limit first',
  'pages.house.repaymentConfig.message.generated': 'Repayment plan generated',
  'pages.house.repaymentConfig.message.setAllMonths': 'Set all months in {year} to ¥{amount}',
  'pages.house.repaymentConfig.message.clearedYear': 'Cleared all months in {year}',
  'pages.house.repaymentConfig.button.setAllMonths': 'Set All',
  'pages.house.repaymentConfig.button.clearYear': 'Clear All',
  'pages.house.repaymentConfig.inputAmountPlaceholder': 'Enter amount',
  'pages.house.repaymentConfig.empty': 'No repayment data. Please click "Generate Plan".',

  // Buttons
  'pages.house.detail.button.close': 'Close',

  // Bills (House detail - bill list)
  'pages.house.billList.filter.billType': 'Fee Type',
  'pages.house.billList.filter.paymentStatus': 'Payment Status',
  'pages.house.billList.filter.paymentStatus.placeholder': 'All statuses',
  'pages.house.billList.filter.paymentStatus.all': 'All statuses',

  'pages.house.billList.billType.property': 'Property Fee',
  'pages.house.billList.billType.water': 'Water Fee',
  'pages.house.billList.billType.electric': 'Electricity Fee',
  'pages.house.billList.billType.network': 'Internet Fee',
  'pages.house.billList.billType.parking': 'Parking Fee',
  'pages.house.billList.billType.other': 'Other Fees',

  'pages.house.billList.action.search': 'Search',
  'pages.house.billList.action.detail': 'Details',
  'pages.house.billList.action.close': 'Close',

  'pages.house.billList.table.columns.period': 'Period',
  'pages.house.billList.table.columns.billNo': 'Bill No.',
  'pages.house.billList.table.columns.finalAmount': 'Amount Due',
  'pages.house.billList.table.columns.approvalStatus': 'Approval Status',
  'pages.house.billList.table.columns.paymentStatus': 'Payment Status',
  'pages.house.billList.table.columns.paidDate': 'Paid Time',
  'pages.house.billList.table.columns.dueDate': 'Due Date',
  'pages.house.billList.table.columns.createdTime': 'Created Time',
  'pages.house.billList.table.columns.action': 'Action',

  'pages.house.billList.empty.noHouse': 'No house information',
  'pages.house.billList.pagination.total': '{from}-{to} / Total {total}',

  'pages.house.billList.modal.title.property': 'Property Fee Bill Details',
  'pages.house.billList.modal.title.water': 'Water Fee Bill Details',
  'pages.house.billList.modal.title.electric': 'Electricity Fee Bill Details',
  'pages.house.billList.modal.title.network': 'Internet Fee Bill Details',
  'pages.house.billList.modal.title.parking': 'Parking Fee Bill Details',
  'pages.house.billList.modal.title.other': 'Other Fee Bill Details',
  'pages.house.billList.modal.title.default': 'Bill Details',

  'pages.house.billList.error.loadBillStatusDictFailed': 'Failed to load bill status dictionary',
  'pages.house.billList.error.loadApproveStatusDictFailed': 'Failed to load approval status dictionary',
  'pages.house.billList.error.loadBillListFailed': 'Failed to load bill list',

  // House detail - utilities/services
  'pages.house.services.table.title': 'Utilities Setup',
  'pages.house.services.table.columns.index': 'No.',
  'pages.house.services.table.columns.serviceName': 'Service Name',
  'pages.house.services.table.columns.unitPrice': 'Unit Price',
  'pages.house.services.table.columns.serviceStatus': 'Service Status',
  'pages.house.services.table.columns.startDate': 'Start Date',
  'pages.house.services.table.columns.endDate': 'End Date',
  'pages.house.services.table.columns.remarks': 'Remarks',
  'pages.house.services.table.columns.operations': 'Operations',
  'pages.house.services.status.enabled': 'Enabled',
  'pages.house.services.status.disabled': 'Disabled',
  'pages.house.services.action.enable': 'Enable',
  'pages.house.services.action.disable': 'Disable',
  'pages.house.services.action.openService': 'Open Service',
  'pages.house.services.confirm.enableService': 'Enable this service?',
  'pages.house.services.confirm.disableService': 'Disable this service?',
  'pages.house.services.message.serviceEnableSuccess': 'Service enabled',
  'pages.house.services.message.serviceDisableSuccess': 'Service disabled',
  'pages.house.services.message.operationFailed': 'Operation failed',
  'pages.house.services.message.getDataFailed': 'Failed to load data',
  'pages.house.services.empty.noHouse': 'No house information',
  'pages.house.services.table.pagination.total':
    '{start}-{end} / Total {total}',

  // Favorite
  'pages.house.favorite.button.favorite': 'Favorite',
  'pages.house.favorite.button.favorited': 'Favorited',
  'pages.house.favorite.message.favoriteSuccess': 'Added to favorites',
  'pages.house.favorite.message.favoriteFailed': 'Failed to add to favorites',
  'pages.house.favorite.message.unfavoriteSuccess': 'Removed from favorites',
  'pages.house.favorite.message.unfavoriteFailed': 'Failed to remove from favorites',
  'pages.house.favorite.message.actionFailed': 'Operation failed',

  // House detail - Warranty & Complaints
  'pages.house.repairComplaint.filter.category': 'Category',
  'pages.house.repairComplaint.filter.status': 'Status',
  'pages.house.repairComplaint.category.maintenance': 'Warranty',
  'pages.house.repairComplaint.category.complaint': 'Complaint',
  'pages.house.repairComplaint.target.workOrder': 'Work Order',
  'pages.house.repairComplaint.target.complaint': 'Complaint',

  'pages.house.repairComplaint.status.pending': 'Pending',
  'pages.house.repairComplaint.status.inProgress': 'In Progress',
  'pages.house.repairComplaint.status.completed': 'Completed',
  'pages.house.repairComplaint.status.resolved': 'Resolved',

  'pages.house.repairComplaint.table.workOrderNo': 'Work Order No.',
  'pages.house.repairComplaint.table.complaintNo': 'Complaint No.',
  'pages.house.repairComplaint.table.repairType': 'Repair Type',
  'pages.house.repairComplaint.table.complaintType': 'Complaint Type',
  'pages.house.repairComplaint.table.title': 'Title',
  'pages.house.repairComplaint.table.urgeCount': 'Urge Count',
  'pages.house.repairComplaint.table.createdTime': 'Created Time',
  'pages.house.repairComplaint.table.status': 'Status',
  'pages.house.repairComplaint.table.action': 'Action',

  'pages.house.repairComplaint.action.startProcess': 'Start',
  'pages.house.repairComplaint.action.addProgress': 'Add Progress',
  'pages.house.repairComplaint.action.complete': 'Complete',
  'pages.house.repairComplaint.action.view': 'View',

  'pages.house.repairComplaint.drawer.detail.title.maintenance': 'Work Order Details',
  'pages.house.repairComplaint.drawer.detail.title.complaint': 'Complaint Details',
  'pages.house.repairComplaint.drawer.start.title': 'Start Processing {type}',
  'pages.house.repairComplaint.drawer.start.confirm': 'Confirm Start',
  'pages.house.repairComplaint.drawer.complete.title': 'Complete',
  'pages.house.repairComplaint.drawer.complete.confirm': 'Confirm Complete',
  'pages.house.repairComplaint.drawer.addProgress.title': 'Add Progress',

  'pages.house.repairComplaint.section.basicInfo': 'Basic Info',
  'pages.house.repairComplaint.section.ownerInfo': 'Owner Info',
  'pages.house.repairComplaint.section.complainantInfo': 'Complainant Info',
  'pages.house.repairComplaint.section.maintenanceDesc': 'Repair Description',
  'pages.house.repairComplaint.section.complaintDesc': 'Complaint Description',
  'pages.house.repairComplaint.section.maintenanceImages': 'Repair Images',
  'pages.house.repairComplaint.section.complaintImages': 'Complaint Images',
  'pages.house.repairComplaint.section.systemInfo': 'System Info',
  'pages.house.repairComplaint.section.progress': 'Progress',
  'pages.house.repairComplaint.section.handleRemark': 'Processing Notes',
  'pages.house.repairComplaint.section.completeRemark': 'Completion Notes',
  'pages.house.repairComplaint.section.addNewProgress': 'Add New Progress',

  'pages.house.repairComplaint.field.workOrderNo': 'Work Order No.',
  'pages.house.repairComplaint.field.complaintNo': 'Complaint No.',
  'pages.house.repairComplaint.field.repairType': 'Repair Type',
  'pages.house.repairComplaint.field.complaintType': 'Complaint Type',
  'pages.house.repairComplaint.field.status': 'Status',
  'pages.house.repairComplaint.field.urgeCount': 'Urge Count',
  'pages.house.repairComplaint.field.ownerName': 'Owner Name',
  'pages.house.repairComplaint.field.ownerPhone': 'Owner Phone',
  'pages.house.repairComplaint.field.ownerEmail': 'Owner Email',
  'pages.house.repairComplaint.field.complainantName': 'Complainant Name',
  'pages.house.repairComplaint.field.complainantPhone': 'Complainant Phone',
  'pages.house.repairComplaint.field.complainantEmail': 'Complainant Email',
  'pages.house.repairComplaint.field.title': 'Title',
  'pages.house.repairComplaint.field.description': 'Description',
  'pages.house.repairComplaint.field.createdTime': 'Created Time',
  'pages.house.repairComplaint.field.updatedTime': 'Updated Time',
  'pages.house.repairComplaint.field.remarks': 'Remarks',

  'pages.house.repairComplaint.form.remark.label': 'Notes',
  'pages.house.repairComplaint.form.remark.required': 'Please enter processing notes',
  'pages.house.repairComplaint.form.complete.required': 'Please enter completion notes',
  'pages.house.repairComplaint.form.remark.min': 'Please enter at least {min} characters',
  'pages.house.repairComplaint.form.remark.placeholder.start': 'Enter notes for starting processing (plan, ETA, etc.)',
  'pages.house.repairComplaint.form.remark.placeholder.complete': 'Enter notes for completion (result, resolution, etc.)',

  'pages.house.repairComplaint.form.progress.required': 'Please enter progress details',
  'pages.house.repairComplaint.form.progress.min': 'Please enter at least {min} characters',
  'pages.house.repairComplaint.form.progress.placeholder': 'Enter progress details for this update',

  'pages.house.repairComplaint.unit.times': '{count} times',
  'pages.house.repairComplaint.image.alt': '{type} image {index}',

  'pages.house.repairComplaint.loading': 'Loading...',
  'pages.house.repairComplaint.empty.noProgress': 'No progress records',
  'pages.house.repairComplaint.empty.noUrge': 'No urges',

  'pages.house.repairComplaint.message.workOrderToInProgress': 'Work order moved to In Progress',
  'pages.house.repairComplaint.message.complaintToInProgress': 'Complaint moved to In Progress',
  'pages.house.repairComplaint.message.workOrderCompleted': 'Work order completed',
  'pages.house.repairComplaint.message.complaintResolved': 'Complaint resolved',
  'pages.house.repairComplaint.message.progressAddSuccess': 'Progress added',

  'pages.house.repairComplaint.error.recordIdMissing': 'Record ID is missing',
  'pages.house.repairComplaint.error.statusChangeFailed': 'Failed to change status',
  'pages.house.repairComplaint.error.completeFailed': 'Failed to complete',
  'pages.house.repairComplaint.error.progressAddFailed': 'Failed to add progress',

  // House selection
  'pages.house.select.current': 'Current Selection: ',
  'pages.house.select.building': 'Building',
  'pages.house.select.floor': 'Floor',

// Currency symbol
'pages.house.currency.symbol': '₱',

// Vehicle form modal
'pages.house.vehicle.form.editTitle': 'Edit Vehicle',
'pages.house.vehicle.form.bindTitle': 'Bind Vehicle',
'pages.house.vehicle.form.parkingInfo': 'Parking Information',
'pages.house.vehicle.form.basicInfo': 'Basic Information',
'pages.house.vehicle.form.remarksInfo': 'Remarks',
'pages.house.vehicle.form.parking': 'Parking Space',
'pages.house.vehicle.form.plateNumber': 'License Plate',
'pages.house.vehicle.form.vehicleType': 'Vehicle Type',
'pages.house.vehicle.form.brand': 'Brand',
'pages.house.vehicle.form.model': 'Model',
'pages.house.vehicle.form.color': 'Color',
'pages.house.vehicle.form.registrationDate': 'Registration Date',
'pages.house.vehicle.form.remarks': 'Remarks',
'pages.house.vehicle.form.plateNumberRequired': 'Please enter license plate number',
'pages.house.vehicle.form.plateNumberMaxLength': 'License plate number cannot exceed 20 characters',
'pages.house.vehicle.form.vehicleTypeRequired': 'Please select vehicle type',
'pages.house.vehicle.form.brandMaxLength': 'Brand cannot exceed 50 characters',
'pages.house.vehicle.form.modelMaxLength': 'Model cannot exceed 50 characters',
'pages.house.vehicle.form.colorMaxLength': 'Color cannot exceed 20 characters',
'pages.house.vehicle.form.remarksMaxLength': 'Remarks cannot exceed 500 characters',
'pages.house.vehicle.form.plateNumberPlaceholder': 'Please enter license plate number',
'pages.house.vehicle.form.vehicleTypePlaceholder': 'Please select vehicle type',
'pages.house.vehicle.form.brandPlaceholder': 'Please enter brand, e.g.: Mercedes, Toyota',
'pages.house.vehicle.form.modelPlaceholder': 'Please enter model, e.g.: C-Class, Corolla',
'pages.house.vehicle.form.colorPlaceholder': 'Please enter vehicle color',
'pages.house.vehicle.form.registrationDatePlaceholder': 'Please select registration date',
'pages.house.vehicle.form.remarksPlaceholder': 'Please enter remarks',
'pages.house.vehicle.form.updateSuccess': 'Update successful',
'pages.house.vehicle.form.createSuccess': 'Create successful',
'pages.house.vehicle.form.updateFailed': 'Update failed',
'pages.house.vehicle.form.createFailed': 'Create failed',

// House form modal
'pages.house.form.editTitle': 'House Sale',
'pages.house.form.createTitle': 'New House',
'pages.house.form.basicInfo': 'Basic Information',
'pages.house.form.ownerInfo': 'Owner Information',
'pages.house.form.saleInfo': 'Sale Information',
'pages.house.form.rentalInfo': 'Rental Information',
'pages.house.form.remarksInfo': 'Remarks',
'pages.house.form.building': 'Building',
'pages.house.form.floor': 'Floor',
'pages.house.form.houseNumber': 'House Number',
'pages.house.form.area': 'Building Area (㎡)',
'pages.house.form.houseType': 'House Type',
'pages.house.form.status': 'House Status',
'pages.house.form.ownerName': 'Owner Name',
'pages.house.form.ownerPhone': 'Owner Phone',
'pages.house.form.saleAmount': 'Sale Amount',
'pages.house.form.discountAmount': 'Discount Amount',
'pages.house.form.finalAmount': 'Final Amount',
'pages.house.form.monthlyRepaymentLimit': 'Monthly Repayment Limit',
'pages.house.form.saleTime': 'Sale Time',
'pages.house.form.rent': 'Rent',
'pages.house.form.rentStartTime': 'Start Time',
'pages.house.form.rentEndTime': 'End Time',
'pages.house.form.remarks': 'Remarks',
'pages.house.form.ownerSearch': 'Search',
'pages.house.form.ownerClear': 'Clear',
'pages.house.form.buildingRequired': 'Please select building',
'pages.house.form.floorRequired': 'Please select floor',
'pages.house.form.houseNumberRequired': 'Please enter house number',
'pages.house.form.houseNumberMaxLength': 'House number cannot exceed 20 characters',
'pages.house.form.areaRequired': 'Please enter building area',
'pages.house.form.areaMaxLength': 'Building area cannot exceed 50 characters',
'pages.house.form.houseTypeRequired': 'Please select house type',
'pages.house.form.statusRequired': 'Please select house status',
'pages.house.form.saleAmountRequired': 'Please enter sale amount',
'pages.house.form.saleAmountMin': 'Sale amount cannot be negative',
'pages.house.form.discountAmountMin': 'Discount amount cannot be negative',
'pages.house.form.finalAmountRequired': 'Please enter final amount',
'pages.house.form.finalAmountMin': 'Final amount cannot be negative',
'pages.house.form.monthlyRepaymentLimitMin': 'Monthly repayment limit cannot be negative',
'pages.house.form.saleTimeRequired': 'Please select sale time',
'pages.house.form.rentRequired': 'Please enter rent',
'pages.house.form.rentMin': 'Rent cannot be negative',
'pages.house.form.rentStartTimeRequired': 'Please select start time',
'pages.house.form.rentEndTimeRequired': 'Please select end time',
'pages.house.form.remarksMaxLength': 'Remarks cannot exceed 500 characters',
'pages.house.form.buildingPlaceholder': 'Please select building',
'pages.house.form.floorPlaceholder': 'Please select floor',
'pages.house.form.houseNumberPlaceholder': 'Please enter house number',
'pages.house.form.areaPlaceholder': 'Please enter building area',
'pages.house.form.houseTypePlaceholder': 'Please select house type',
'pages.house.form.statusPlaceholder': 'Please select house status',
'pages.house.form.ownerNamePlaceholder': 'Please search and select owner',
'pages.house.form.ownerPhonePlaceholder': 'Please search and select owner',
'pages.house.form.saleAmountPlaceholder': 'Please enter sale amount',
'pages.house.form.discountAmountPlaceholder': 'Please enter discount amount',
'pages.house.form.finalAmountPlaceholder': 'Auto calculated',
'pages.house.form.monthlyRepaymentLimitPlaceholder': 'Please enter monthly repayment limit',
'pages.house.form.saleTimePlaceholder': 'Please select sale time',
'pages.house.form.rentPlaceholder': 'Please enter rent',
'pages.house.form.rentStartTimePlaceholder': 'Please select start time',
'pages.house.form.rentEndTimePlaceholder': 'Please select end time',
'pages.house.form.remarksPlaceholder': 'Please enter remarks',
'pages.house.form.areaReceipt': 'Unit Price per sqm',
'pages.house.form.areaReceiptPlaceholder': 'Please enter unit price per sqm',
'pages.house.form.bindingInfo': 'Binding Information',
'pages.house.form.tab.basic': 'Basic Information',
'pages.house.form.tab.reserved': 'House Reservation',
'pages.house.form.tab.sold': 'House Sale',
'pages.house.form.tab.rented': 'House Rental',
'pages.house.form.tab.finance': 'Financial Registration',
'pages.house.form.tab.repayment': 'House Repayment',
'pages.house.form.tab.document': 'Related Documents',
'pages.house.form.tab.operationLog': 'Operation Log',
'pages.house.form.reserved.section.info': 'Reservation Information',
'pages.house.form.reserved.reserveUserName': 'Reserved By',
'pages.house.form.reserved.reserveUserNamePlaceholder': 'Please enter reserver name',
'pages.house.form.reserved.reserveUserNameMaxLength':
  'Reserver name cannot exceed 50 characters',
'pages.house.form.reserved.reserveUserPhone': 'Reserved Phone',
'pages.house.form.reserved.reserveUserPhonePlaceholder':
  'Please enter reserver phone',
'pages.house.form.reserved.reserveTime': 'Reservation Time',
'pages.house.form.reserved.reserveTimePlaceholder':
  'Please select reservation time',
'pages.house.form.reserved.section.agentInfo': 'Agent Information',
'pages.house.form.reserved.agent': 'House Agent',
'pages.house.form.reserved.agentPlaceholder': 'Please select house agent',
'pages.house.form.button.cancelReservation': 'Cancel Reservation',
'pages.house.form.button.cancelSale': 'Cancel Sale',
'pages.house.form.button.cancelRent': 'Cancel Rental',
'pages.house.form.updateSuccess': 'Update successful',
'pages.house.form.createSuccess': 'Create successful',
'pages.house.form.updateFailed': 'Update failed',
'pages.house.form.createFailed': 'Create failed',

// House finance record modal
'pages.house.financeModal.title.create': 'Create Financial Record',
'pages.house.financeModal.label.houseInfo': 'House Info',
'pages.house.financeModal.label.amountType': 'Amount Type',
'pages.house.financeModal.label.amount': 'Amount',
'pages.house.financeModal.label.bankStatement': 'Bank Statement',
'pages.house.financeModal.label.remarks': 'Remarks',
'pages.house.financeModal.placeholder.amountType': 'Please select amount type',
'pages.house.financeModal.placeholder.feeType': 'Please select fee type',
'pages.house.financeModal.placeholder.amount': 'Please enter amount',
'pages.house.financeModal.placeholder.bankStatement': 'Please enter keywords to search bank statements',
'pages.house.financeModal.placeholder.remarks': 'Please enter remarks',
'pages.house.financeModal.validation.amountTypeRequired': 'Please select amount type',
'pages.house.financeModal.validation.feeTypeRequired': 'Please select fee type',
'pages.house.financeModal.validation.amountRequired': 'Please enter amount',
'pages.house.financeModal.validation.bankStatementRequired': 'Please select bank statement',
'pages.house.financeModal.amountType.income': 'Income',
'pages.house.financeModal.amountType.expense': 'Expense',
'pages.house.financeModal.dictLabel.realEstateFeeType': 'Real Estate Fee Type',
'pages.house.financeModal.message.houseIdMissing': 'House ID does not exist',
'pages.house.financeModal.message.createSuccess': 'Financial record created successfully',
'pages.house.financeModal.message.createFailed': 'Failed to create financial record',
'pages.house.financeModal.message.createFailedRetry': 'Failed to create financial record, please try again later',

// Owner selection modal
'pages.house.owner.modal.title': 'Select Owner',
'pages.house.owner.modal.okText': 'Confirm Selection',
'pages.house.owner.modal.cancelText': 'Cancel',
'pages.house.owner.select.placeholder': 'Please select an owner',
'pages.house.owner.select.required': 'Please select an owner first',
'pages.house.owner.bind.button': 'Bind Owner',
'pages.house.owner.bind.success': 'Owner bound successfully',
'pages.house.owner.bind.failed': 'Failed to bind owner',
'pages.house.owner.unbind.button': 'Unbind',
'pages.house.owner.unbind.confirm.title': 'Confirm unbinding the current owner?',
'pages.house.owner.unbind.success': 'Unbound successfully',
'pages.house.owner.unbind.failed': 'Failed to unbind',
'pages.house.owner.table.select': 'Select',
'pages.house.owner.table.username': 'Username',
'pages.house.owner.table.name': 'Name',
'pages.house.owner.table.phone': 'Phone',
'pages.house.owner.table.email': 'Email',
'pages.house.owner.table.idCard': 'ID Card',
'pages.house.owner.table.status': 'Status',
'pages.house.owner.status.enabled': 'Active',
'pages.house.owner.status.disabled': 'Disabled',

// Building floor tree
'pages.house.buildingTree.title': 'Building & Floor Selection',

// Rental house management
'pages.house.rental.pageTitle': 'Rental House Management',
'pages.house.rental.breadcrumb.rental': 'Rental Management',
'pages.house.rental.breadcrumb.rentalHouse': 'Rental House Management',
'pages.house.rental.action.create': 'Create',
'pages.house.rental.action.search': 'Search',
'pages.house.rental.action.view': 'View',
'pages.house.rental.action.addSnapshot': 'Add Snapshot',
'pages.house.rental.action.addAttachment': 'Add Attachment',
'pages.house.rental.action.download': 'Download',
'pages.house.rental.status.notRented': 'Not Rented',
'pages.house.rental.status.rented': 'Rented',
'pages.house.rental.status.vacant': 'Vacant',
'pages.house.rental.filter.hasBalcony': 'Has Balcony:',
'pages.house.rental.balcony.has': 'Has Balcony',
'pages.house.rental.balcony.none': 'No Balcony',
'pages.house.rental.search.aliasPlaceholder': 'Please enter house alias (fuzzy search)',
'pages.house.rental.empty.noData': 'No data',
'pages.house.rental.empty.noImage': 'No image',
'pages.house.rental.empty.noPhotos': 'No house photos yet, please add snapshot',
'pages.house.rental.empty.noAttachments': 'No attachments yet, please add one',
'pages.house.rental.card.monthlyRent': 'Monthly Rent: {price}',
'pages.house.rental.confirm.delete': 'Are you sure to delete this rental house record?',
'pages.house.rental.pagination.total': '{from}-{to} / Total {total}',
'pages.house.rental.message.listFailed': 'Failed to fetch rental house list',
'pages.house.rental.message.deleteMissingId': 'Missing ID, delete failed',
'pages.house.rental.message.deleteSuccess': 'Deleted successfully',
'pages.house.rental.message.deleteFailed': 'Delete failed',
'pages.house.rental.message.imageOnly': 'Only image files are supported',
'pages.house.rental.message.imageLimit': 'Image size cannot exceed 5MB',
'pages.house.rental.message.photoUploadSuccess': 'Photo uploaded successfully',
'pages.house.rental.message.fileLimit': 'File size cannot exceed 10MB',
'pages.house.rental.message.attachmentUploadSuccess': 'Attachment uploaded successfully',
'pages.house.rental.message.updateSuccess': 'Updated successfully',
'pages.house.rental.message.updateFailed': 'Update failed',
'pages.house.rental.message.createSuccess': 'Created successfully',
'pages.house.rental.message.createFailed': 'Create failed',
'pages.house.rental.form.title.edit': 'Edit Rental House',
'pages.house.rental.form.title.create': 'Create Rental House',
'pages.house.rental.tab.basic': 'Basic Information',
'pages.house.rental.tab.photos': 'House Photos',
'pages.house.rental.tab.files': 'File Attachments',
'pages.house.rental.tab.extra': 'Additional Information',
'pages.house.rental.section.basic': 'Basic Information',
'pages.house.rental.section.rental': 'Rental Information',
  'pages.house.rental.section.ownerInfo': 'Owner Information',
'pages.house.rental.section.agent': 'Agent Information',
'pages.house.rental.section.extra': 'Additional Information',
'pages.house.rental.form.alias': 'House Alias',
'pages.house.rental.form.layout': 'Layout',
'pages.house.rental.form.area': 'House Area (㎡)',
'pages.house.rental.form.hasBalcony': 'Has Balcony',
'pages.house.rental.form.status': 'Rental Status',
'pages.house.rental.form.location': 'House Location',
  'pages.house.rental.form.houseUser': 'Owner Name',
  'pages.house.rental.form.houseUserMobile': 'Owner Phone',
'pages.house.rental.form.rentalPrice': 'Monthly Rent',
'pages.house.rental.form.estimatedPrice': 'Purchase Price',
'pages.house.rental.form.agentName': 'Agent Name',
'pages.house.rental.form.agentFee': 'Agent Fee',
'pages.house.rental.form.remarks': 'Remarks',
'pages.house.rental.form.homeList': 'Appliance List',
'pages.house.rental.form.description': 'Other Supplementary Description',
'pages.house.rental.form.name': 'Name',
'pages.house.rental.form.snapshotUpload': 'Snapshot Image (supports JPG/PNG, <=5MB)',
'pages.house.rental.form.attachmentUpload': 'Attachment File (supports common formats, <=10MB)',
'pages.house.rental.placeholder.alias': 'Please enter house alias',
'pages.house.rental.placeholder.layout': 'Example: Two Bedrooms and One Living Room',
'pages.house.rental.placeholder.area': 'Please enter area',
'pages.house.rental.placeholder.select': 'Please select',
'pages.house.rental.placeholder.status': 'Please select rental status',
'pages.house.rental.placeholder.location': 'Please enter house location',
  'pages.house.rental.placeholder.houseUser': 'Please enter owner name',
  'pages.house.rental.placeholder.houseUserMobile': 'Please enter owner phone',
'pages.house.rental.placeholder.rentalPrice': 'Please enter monthly rent',
'pages.house.rental.placeholder.estimatedPrice': 'Please enter purchase price',
'pages.house.rental.placeholder.agentName': 'Please enter agent name',
'pages.house.rental.placeholder.agentFee': 'Please enter agent fee',
'pages.house.rental.placeholder.remarks': 'Please enter remarks',
'pages.house.rental.placeholder.homeList': 'Please enter appliance list',
'pages.house.rental.placeholder.description': 'Please enter supplementary description',
'pages.house.rental.placeholder.photoName': 'Please enter photo name',
'pages.house.rental.placeholder.attachmentName': 'Please enter attachment name',
'pages.house.rental.validation.aliasRequired': 'Please enter house alias',
'pages.house.rental.validation.hasBalconyRequired': 'Please select whether there is a balcony',
'pages.house.rental.validation.statusRequired': 'Please select rental status',
'pages.house.rental.validation.locationRequired': 'Please enter house location',
'pages.house.rental.validation.nameRequired': 'Please enter name',
'pages.house.rental.validation.attachmentNameRequired': 'Please enter attachment name',
'pages.house.rental.validation.uploadPhotoFirst': 'Please upload image first',
'pages.house.rental.validation.uploadAttachmentFirst': 'Please upload attachment first',
'pages.house.rental.option.yes': 'Yes',
'pages.house.rental.option.no': 'No',
'pages.house.rental.photo.title': 'House Photos',
'pages.house.rental.photo.tip':
  'The first image will be used as the display image for rental house.',
'pages.house.rental.photo.defaultName': 'House Photo',
'pages.house.rental.file.title': 'Attachments',
'pages.house.rental.file.defaultName': 'Attachment',
'pages.house.rental.modal.photoCreateTitle': 'Add House Photo',
'pages.house.rental.modal.attachmentCreateTitle': 'Add Attachment',
'pages.house.rental.modal.previewPhotoTitle': 'View Photo',
'pages.house.rental.upload.photo.text': 'Click or drag to upload house image',
'pages.house.rental.upload.photo.hint':
  'Supports JPG and PNG, file size no more than 5MB',
'pages.house.rental.upload.attachment.text': 'Click or drag to upload attachment file',
'pages.house.rental.upload.attachment.hint':
  'Supports PDF, Word, Excel, images and other common formats, file size no more than 10MB',
'pages.house.rental.upload.loading': 'Uploading...',
'pages.house.rental.appliance.tv': 'TV',
'pages.house.rental.appliance.fridge': 'Refrigerator',
'pages.house.rental.appliance.microwave': 'Microwave',
'pages.house.rental.appliance.riceCooker': 'Rice Cooker',
'pages.house.rental.appliance.kettle': 'Kettle',
'pages.house.rental.appliance.washer': 'Washing Machine',
'pages.house.rental.appliance.bed': 'Bed',
'pages.house.rental.appliance.table': 'Table',
'pages.house.rental.appliance.ac': 'Air Conditioner',
'pages.house.rental.appliance.waterHeater': 'Water Heater',
'pages.house.rental.appliance.sofa': 'Sofa',
'pages.house.rental.appliance.wardrobe': 'Wardrobe',

// Common action keys
'common.action.create': 'Create',
'common.action.add': 'Add',
'common.action.edit': 'Edit',
'common.action.delete': 'Delete',
'common.action.confirm': 'Confirm',
'common.action.cancel': 'Cancel',
'common.action.clear': 'Clear',
'common.action.deselect': 'Deselect',
'common.action.batchDelete': 'Batch Delete',
'common.label.selected': 'Selected',
'common.label.items': 'items',
'common.confirm.delete': 'Are you sure you want to delete this record?',
'common.confirm.batchDelete': 'Are you sure you want to batch delete the selected records?',
};
